import { USD } from 'helpers/formatters/number_formats';

export function isReadOnly(plan) {
  return plan.payablesCount > 0 || plan.archived;
}

export function formatTiers(tiers) {
  let previousTier;

  return tiers.map((tier) => {
    const normalizedTier = { ...tier };

    if (!previousTier) {
      normalizedTier.formattedFrom = USD.format(0, { round: true });
    } else {
      if (previousTier.to != null) {
        normalizedTier.formattedFrom = USD.format(previousTier.to + 0.01, { round: false });
      }
    }

    if (!tier._destroy) {
      previousTier = tier;
    }

    return normalizedTier;
  });
}
